import { mapAtom } from '../../atoms/map/map'
import { findLayer } from '../utils/findLayer'

export const clearVehicleFeatures = () => {
  const map = mapAtom.map
  const layer = findLayer(map, 'vehicle')

  layer.getSource()?.clear()
}
